import { render, staticRenderFns } from "./PrintPosTkModular.vue?vue&type=template&id=918f8f62&scoped=true"
import script from "./PrintPosTkModular.vue?vue&type=script&lang=js"
export * from "./PrintPosTkModular.vue?vue&type=script&lang=js"
import style0 from "./PrintPosTkModular.vue?vue&type=style&index=0&id=918f8f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918f8f62",
  null
  
)

export default component.exports